import React from "react";
import "./loader.css";
import Icon from "../icon/icon";

export function Loader({ loading, error, children }) {
  if (loading) {
    return (
      <div className="min-h-[400px] flex flex-col items-center justify-center gap-4">
        <div className="relative">
          <div className="w-12 h-12 rounded-full border-3 border-primary/20 border-t-primary animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
          </div>
        </div>
        <div className="text-center">
          <p className="text-sm font-semibold text-slate-700">Cargando mediciones ambientales...</p>
          <p className="text-xs text-slate-400">Consultando datos del sensor IoT</p>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="min-h-[350px] flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-rose-50/70 border border-rose-200/80 rounded-2xl p-6 text-center shadow-sm">
          <div className="w-12 h-12 rounded-xl bg-rose-100 text-rose-600 flex items-center justify-center mx-auto mb-3">
            <Icon className="text-2xl">triangle-exclamation</Icon>
          </div>
          <h3 className="text-slate-900 text-base font-bold mb-1">
            No se pudieron obtener los datos
          </h3>
          <p className="text-xs text-slate-600">
            Hubo un problema al conectar con el servidor de telemetría. Por favor verifique la conexión o intente más tarde.
          </p>
        </div>
      </div>
    );
  }
  return children;
}

